export class ItemDisplayData 
{
    public ID;
    public UniversalID;
    public Thumbnail;
    public Picture;
    public Name;
    public Description;
    public SubDescription;
    public OriginalPriceString;
    public PriceString;
    public Type;
    public OutOfStock;
    public WaitTime;

    public constructor(id:string, universalID:string, thumbnail:string, picture:string, name:string, description:string, originalpricestring:string, pricestring:string, type:string, outofstock:boolean, waittime:string)
    {
        this.ID = id;
        this.UniversalID = universalID;
        this.Thumbnail = thumbnail;
        this.Picture = picture;
        this.Name = this.truncate(name, 30);
        this.Description = description;
        this.SubDescription = this.truncate(this.Description, 60);
        this.OriginalPriceString = originalpricestring;
        this.PriceString = pricestring;
        this.Type = type;
        this.OutOfStock = outofstock;
        this.WaitTime = waittime;
    }

    truncate(input:string, amount:number) 
    {
        if(input)
        {
            if ( input &&input.length > amount)
                return input.substring(0, amount) + '...';

            return input;
        }

        return "";
     };
}
